import { LEFTRIGHT_PADDING } from "../config/style.config";
export default function Component(){
    return(
        <div className="flex-col bg-[#0C0D14] flex-1 text-[14px] text-white">
                <div style={{...LEFTRIGHT_PADDING}} className='pb-64 flex flex-col items-center justify-center mt-10'>
                    No Permission
                </div>
            </div>
    )
}